'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var regions = require('./regions');
var vendorProductTypes = require('./constants/vendorProductTypes');
var canonicalDomains = require('./canonicalDomains');
var roleTypes = require('./constants/roleTypes');
var roleTypesAsNamedParameter = require('./constants/roleTypesAsNamedParameter');
var serviceTypes = require('./constants/serviceTypes');
var serviceTypesAsNamedParameter = require('./constants/serviceTypesAsNamedParameter');
var deviceTypes = require('./constants/deviceTypes');
var storageTypes = require('./constants/storageTypes');
var cloudStorageConfigTypes = require('./constants/cloudStorageConfigTypes');
var constants = require('./constants');
var utils = require('./utils');
var deviceCommunication = require('./constants/deviceCommunication');
var snsEvents = require('./constants/snsEvents');
var productCategory = require('./constants/productCategory');
var addressGranularities = require('./constants/addressGranularities');
var scheduleSnsEvents = require('./constants/scheduleSnsEvents');
var scheduleTypes = require('./constants/scheduleTypes');
var transferDirections = require('./constants/transferDirections');
var changePasswordRequestStates = require('./constants/changePasswordRequestStates');
var transferRateLimitUnits = require('./constants/transferRateLimitUnits');

//At the time of this writing, these were formerly from jet-common
var actionBacklogStates = require('./constants/actionBacklogStates');
var actionBacklogStreamEventTypes = require('./constants/actionBacklogStreamEventTypes');
var actionExecutionEventTypes = require('./constants/actionExecutionEventTypes');
var actionExecutionStates = require('./constants/actionExecutionStates');
var actionTypes = require('./constants/actionTypes');
var aggregationTopicArns = require('./constants/aggregationTopicArns');
var aggregationEventTypes = require('./constants/aggregationEventTypes');
var msAssets = require('./constants/msAssets');
var msFormDefinitions = require('./constants/msFormDefinitions');
var deletionBatchStates = require('./constants/deletionBatchStates');
var deliveryStates = require('./constants/deliveryStates');
var deviceCommunicationServiceEvents = require('./constants/deviceCommunicationServiceEvents');
var deviceEvents = require('./constants/deviceEvents');
var deviceLocationResolutionMethods = require('./constants/deviceLocationResolutionMethods');

var _require = require('./constants'),
    endpointTypes = _require.endpointTypes,
    isCloudEndpointType = _require.isCloudEndpointType,
    isCloudStorageProfileType = _require.isCloudStorageProfileType,
    storageProfileTypes = _require.storageProfileTypes;

var endpointVisibility = require('./constants/endpointVisibility');
var endpointStates = require('./constants/endpointStates');
var errorCodes = require('./constants/errorCodes');
var errorMessages = require('./constants/errorMessages');
var errorHandlingPolicies = require('./constants/errorHandlingPolicies');
var fileDeletionEvents = require('./constants/fileDeletionEvents');
var fileDeletionStates = require('./constants/fileDeletionStates');
var fileMoveEvents = require('./constants/fileMoveEvents');
var fileMoveStates = require('./constants/fileMoveStates');
var fileStates = require('./constants/fileStates');
var fileTransfersSnsEvents = require('./constants/fileTransfersSnsEvents');
var fileTypes = require('./constants/fileTypes');
var folderMonitorInitializationStatuses = require('./constants/folderMonitorInitializationStatuses');
var folderMonitorStartModes = require('./constants/folderMonitorStartModes');
var folderMonitorWalkModes = require('./constants/folderMonitorWalkModes');
var folderMonitorWalkStates = require('./constants/folderMonitorWalkStates');
var hotFolderEventTypes = require('./constants/hotFolderEventTypes');
var jetDeletionEventStatusCodes = require('./constants/jetDeletionEventStatusCodes');
var jetMetricRawDataKeys = require('./constants/jetMetricRawDataKeys');
var jetMoveEventStatusCodes = require('./constants/jetMoveEventStatusCodes');
var jetVersions = require('./constants/jetVersions');
var jobSnsEvents = require('./constants/jobSnsEvent');
var jobTriggerTypes = require('./constants/jobTriggerTypes');
var jobTypes = require('./constants/jobTypes');
var licenseServiceTypes = require('./constants/licenseServiceTypes');
var licenseStatuses = require('./constants/licenseStatuses');
var moveBatchStates = require('./constants/moveBatchStates');
var resourceStatusStates = require('./constants/resourceStatusStates');
var resourceTypes = require('./constants/resourceTypes');
var routeTypes = require('./constants/routeTypes');
var signiantCommunicationServiceVersions = require('./constants/signiantCommunicationServiceVersions');
var storageProfileVisibility = require('./constants/storageProfileVisibility');
var tokenStates = require('./constants/tokenStates');
var transferEvents = require('./constants/transferEvents');
var transferStates = require('./constants/transferStates');
var transferTypes = require('./constants/transferTypes');
var transferReasonCodes = require('./constants/transferReasonCodes');
var userConstants = require('./constants/userConstants');
var mandaEvents = require('./constants/mandaEvents');
var platformEventNotifications = require('./constants/platformEventNotifications');
var postAggregationActions = require('./constants/postAggregationActions');
var mediaShuttle = require('./constants/mediaShuttle');
var tags = require('./constants/tags');
var metricExclusionTypes = require('./constants/metricExclusionTypes');
var jetTransferErrorReasons = require('./constants/jetTransferErrorReasons');
var metricGroupTypes = require('./constants/metricGroupTypes');
var registeredJwtClaims = require('./constants/registeredJwtClaims');
var jetLogLevels = require('./constants/jetLogLevels');
var jetRelays = require('./constants/jetRelays');
var emailSenders = require('./constants/emailSenders');
var exportJwtPrivateClaimKeys = require('./constants/exportJwtPrivateClaimKeys');
var jetMappers = require('./mappers/jet/index');
var mediaShuttleMappers = require('./mappers/mediaShuttle/index');
var auditLog = require('./constants/auditLog');
var mandaJobRunStatusTypes = require('./constants/mandaJobRunStatusTypes');
var webSocketRequestActionTypes = require('./constants/webSocketRequestActionTypes');
var webSocketMessageEventTypes = require('./constants/webSocketMessageEventTypes');
var s3BucketAccessStyle = require('./constants/s3BucketAccessStyle');
var msPortalStatusReasons = require('./constants/msPortalStatusReasons');

module.exports = _extends({}, regions, canonicalDomains, {
    roleTypes: roleTypes,
    roleTypesAsNamedParameter: roleTypesAsNamedParameter,
    serviceTypes: serviceTypes,
    serviceTypesAsNamedParameter: serviceTypesAsNamedParameter,
    deviceTypes: deviceTypes,
    storageTypes: storageTypes,
    vendorProductTypes: vendorProductTypes,
    cloudStorageConfigTypes: cloudStorageConfigTypes,
    deviceCommunication: deviceCommunication,
    snsEvents: snsEvents,
    actionBacklogStates: actionBacklogStates,
    actionBacklogStreamEventTypes: actionBacklogStreamEventTypes,
    actionExecutionEventTypes: actionExecutionEventTypes,
    actionExecutionStates: actionExecutionStates,
    actionTypes: actionTypes,
    changePasswordRequestStates: changePasswordRequestStates,
    deletionBatchStates: deletionBatchStates,
    deliveryStates: deliveryStates,
    deviceCommunicationServiceEvents: deviceCommunicationServiceEvents,
    deviceEvents: deviceEvents,
    deviceLocationResolutionMethods: deviceLocationResolutionMethods,
    endpointTypes: endpointTypes,
    endpointVisibility: endpointVisibility,
    endpointStates: endpointStates,
    errorCodes: errorCodes,
    errorMessages: errorMessages,
    errorHandlingPolicies: errorHandlingPolicies,
    fileDeletionEvents: fileDeletionEvents,
    fileDeletionStates: fileDeletionStates,
    fileMoveEvents: fileMoveEvents,
    fileMoveStates: fileMoveStates,
    fileStates: fileStates,
    fileTransfersSnsEvents: fileTransfersSnsEvents,
    fileTypes: fileTypes,
    folderMonitorInitializationStatuses: folderMonitorInitializationStatuses,
    folderMonitorStartModes: folderMonitorStartModes,
    folderMonitorWalkModes: folderMonitorWalkModes,
    folderMonitorWalkStates: folderMonitorWalkStates,
    hotFolderEventTypes: hotFolderEventTypes,
    jetDeletionEventStatusCodes: jetDeletionEventStatusCodes,
    jetMetricRawDataKeys: jetMetricRawDataKeys,
    jetMoveEventStatusCodes: jetMoveEventStatusCodes,
    jetVersions: jetVersions,
    jobSnsEvents: jobSnsEvents,
    jobTriggerTypes: jobTriggerTypes,
    jobTypes: jobTypes,
    licenseServiceTypes: licenseServiceTypes,
    licenseStatuses: licenseStatuses,
    moveBatchStates: moveBatchStates,
    resourceStatusStates: resourceStatusStates,
    resourceTypes: resourceTypes,
    routeTypes: routeTypes,
    scheduleSnsEvents: scheduleSnsEvents,
    scheduleTypes: scheduleTypes,
    signiantCommunicationServiceVersions: signiantCommunicationServiceVersions,
    storageProfileTypes: storageProfileTypes,
    storageProfileVisibility: storageProfileVisibility,
    tokenStates: tokenStates,
    transferEvents: transferEvents,
    transferRateLimitUnits: transferRateLimitUnits,
    transferStates: transferStates,
    transferTypes: transferTypes,
    transferReasonCodes: transferReasonCodes,
    userConstants: userConstants,
    addressGranularities: addressGranularities,
    jetTransferErrorReasons: jetTransferErrorReasons,
    jetLogLevels: jetLogLevels,
    jetRelays: jetRelays,
    emailSenders: emailSenders,
    msPortalStatusReasons: msPortalStatusReasons
}, {
    constants: constants,
    utils: utils,
    productCategory: productCategory,
    mandaEvents: mandaEvents,
    mandaJobRunStatusTypes: mandaJobRunStatusTypes,
    mediaShuttle: mediaShuttle,
    platformEventNotifications: platformEventNotifications,
    postAggregationActions: postAggregationActions,
    aggregationTopicArns: aggregationTopicArns,
    aggregationEventTypes: aggregationEventTypes,
    msAssets: msAssets,
    msFormDefinitions: msFormDefinitions,
    tags: tags,
    metricExclusionTypes: metricExclusionTypes,
    metricGroupTypes: metricGroupTypes,
    transferDirections: transferDirections,
    registeredJwtClaims: registeredJwtClaims,
    exportJwtPrivateClaimKeys: exportJwtPrivateClaimKeys,
    jetMappers: jetMappers,
    mediaShuttleMappers: mediaShuttleMappers,
    auditLog: auditLog,
    isCloudEndpointType: isCloudEndpointType,
    isCloudStorageProfileType: isCloudStorageProfileType,
    webSocketRequestActionTypes: webSocketRequestActionTypes,
    webSocketMessageEventTypes: webSocketMessageEventTypes,
    s3BucketAccessStyle: s3BucketAccessStyle
});